import { Component } from '@angular/core';
import { OperationService } from 'src/app/demo/service/operation.service';
import { WebStorage } from '../../../auth/storage/web.storage';
import { LookupService } from 'src/app/demo/service/lookup.service';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { RoomDTO } from 'src/app/demo/model/RoomDTO';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { forkJoin, Observable } from 'rxjs';
import { StaffDTO } from 'src/app/demo/model/StaffDTO';
import { Common } from 'src/app/demo/utils/common';
import { AttendanceDTO } from 'src/app/demo/model/AttendanceDTO';
import { StudentDTO } from 'src/app/demo/model/StudentDTO';
import { MasterLookupDTO } from 'src/app/demo/model/MasterLookupDTO';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { profielBackgroundColor } from 'src/app/demo/sharing/constants/profielBackgroundColor';
import * as moment from 'moment';
import { DashboardSchoolDTO } from 'src/app/demo/model/DashboardSchoolDTO';
import { DomSanitizer } from '@angular/platform-browser';
import { ITEMS_PER_PAGE, PAGE_SIZE } from 'src/app/demo/constants/pagination.constants';

@Component({
    selector: 'app-sign-out',
    templateUrl: './sign-out.component.html',
    styleUrls: ['./sign-out.component.scss'],
})
export class SignOutComponent {
    userData: any;
    search: any = {};
    pageContext = {
        page: 0,
        previousPage: 0,
        itemsPerPage: 100,
        totalItems: 0,
        sort: 'staffName,asc',
    };
    roomList: RoomDTO[] = [];
    roomObj: RoomDTO = {};
    designationList: MasterLookupDTO[] = [];
    selectedRoomId: any;
    selectedDesignation: any;
    selectedStatus: any;
    staffList: any[] = [];
    selectAllStaff: boolean = false;
    selectedStaff: any[] = [];
    selectedStudentIds: number[] = [];
    selectedStaffList: any[] = [];
    actualStaffList: StaffDTO[] = [];
    staffSearchInput: any;
    submitForm: boolean = false;
    items!: MenuItem[];
    activeIndex: number = 0;
    profileBgColor: string[] = [];
    selectedDate: any = Common.momentTimeZoneDate(new Date());
    staffObj: StaffDTO = {};
    staffSignIn!: FormGroup;
    isClickedOnce: boolean = false;
    currentAttendanceOf!: any;
    staffAttendance!: AttendanceDTO;
    fromOverView : boolean = false;
    selectedStaffsFromOverview : any []=[];
    today: string = Common.momentTimeZoneDate(new Date());

    
    constructor(
        private lookupService: LookupService,
        private operationService: OperationService,
        private storage: WebStorage,
        private formBuilder: FormBuilder,
        private messageService: MessageService,
        public ref: DynamicDialogRef,
        public config: DynamicDialogConfig,
        private confirmationService: ConfirmationService,
        private sanitizer: DomSanitizer,
    ) {
        this.roomObj = this.config.data;
        this.profileBgColor = profielBackgroundColor;
        this.currentAttendanceOf = config.data.formName;
        this.activeIndex = this.config.data.activeIndex;
        this.fromOverView = this.config.data.fromOverView;
        this.selectedStaffsFromOverview = this.fromOverView ? this.config.data.selectedStaffs : [];
    }

    ngOnInit(): void {
        this.userData = this.storage.getUserData();
        const currentTime24hr = Common.momentTimeZoneTime(new Date());
        const currentDate = Common.momentTimeZoneDate(new Date());

        this.items = [
            {
                label: 'Select Staff',
                command: (event: any) =>
                    this.messageService.add({
                        severity: 'info',
                        summary: 'First Step',
                        key: 'message',
                        detail: event.item.label,
                        life: 3000,
                    }),
            },
            {
                label: 'Confirm Staff',
                command: (event: any) =>
                    this.messageService.add({
                        severity: 'info',
                        key: 'message',
                        summary: 'Second Step',
                        detail: event.item.label,
                        life: 3000,
                    }),
            },
        ];
        this.staffSignIn = this.formBuilder.group({
            id: [''],
            signInTime: [''],
            signOutTime: [currentTime24hr],
            attendedTime: [''],
            signInBy: [''],
            signOutBy: [''],
            note: [''],
            hasSignIn: [false],
            date: [currentDate],
            roomId: [''],
            staffName: [''],
            status: 'A',
            schoolId: [''],
            hasStudentId: [''],
        });
        this.queryData();
        this.getRoomData();
        this.getDesignationData();

        this.lookupService
            .getStaffById(this.userData.refTableId)
            .subscribe((res: HttpResponse<StaffDTO>) => {
                let temp: StaffDTO = {};
                this.staffObj = res.body ? res.body : temp;
                this.queryData();
            });

        this.staffSignIn.get('date')?.valueChanges.subscribe((val: string) => {
            if (!val) return;

            const today = moment().startOf('day');
            const selected = moment(val, 'YYYY-MM-DD').startOf('day');

            if (selected.isAfter(today)) {
                this.staffSignIn.get('date')?.setValue(today.format('YYYY-MM-DD'));
            }
        });
    }

    onActiveIndexChange(event: number) {
        this.activeIndex = event;
    }

    complete() {
        if (this.selectedStudentIds.length != 0) {
            this.activeIndex = 1;
        } else {
            this.activeIndex = 0;
        }
    }

    prevPage() {
        this.activeIndex = 0;
    }

    buttonDisabled: boolean = false;
    onSave() {
        this.buttonDisabled = true;
        if (Array.isArray(this.selectedStaff)) {
            const studentIds = this.selectedStaff.map((item) => item.id).join(',');
            const formatTo12Hour = (time: string): string => {
                if (!time) return ''; // Handle undefined or null cases
                const [hours, minutes] = time.split(':'); // Extract hours and minutes
                let hour = parseInt(hours, 10);
                const ampm = hour >= 12 ? 'PM' : 'AM';
                hour = hour % 12 || 12; // Convert 0/24 to 12
                return `${hour
                    .toString()
                    .padStart(2, '0')}:${minutes}:00 ${ampm}`; // Add seconds as 00
            };
            const invalidStudents: string[] = []; // Collect names/IDs of students with incorrect sign-out time
            this.selectedStaff.forEach((student: {
                staffName: any; id: any, signInTime: any
            }) => {                
                if (this.isSignOutBeforeSignIn(student.signInTime, formatTo12Hour(this.staffSignIn.value.signOutTime))) {
                    invalidStudents.push(student.staffName);
                }
            });

            if (invalidStudents.length > 0) {
                alert(`${invalidStudents.join(', ')}'s Sign-Out Time cannot be same or before Sign-In Time.`);
                return;
            }
            else {
                const updateAttendance: any = {
                    signOutStaffId: this.userData.refTableId,
                    signOutBy: this.userData?.firstName,
                    signOutTime: this.staffSignIn.value.signOutTime ? formatTo12Hour(this.staffSignIn.value.signOutTime) : undefined,
                    schoolId: this.userData.schoolId,
                    hasSignIn: false,
                    // signInTime: student.signInTime // Assuming signInTime is the same for each student
                };
                this.operationService.updateAttendanceAll(updateAttendance, studentIds).subscribe((res: HttpResponse<AttendanceDTO>) => {
                    this.selectedStaffList = [];
                    const messages = {
                        severity: 'success',
                        life: 3000,
                        summary: 'Success',
                        detail: `All staff signed out successfully.`,
                    };
                    this.submitForm = false;
                    this.ref.close(messages);
                    this.buttonDisabled = false;
                },
                    (error) => {
                        this.messageService.add({
                            severity: 'error',
                            life: 3000,
                            summary: 'Error',
                            detail: 'Failed to sign out some staff members.',
                        });
                        this.buttonDisabled = false;
                    });
            }
        }
    }
    
    isSignOutBeforeSignIn(signInTime: string | undefined, signOutTime: string | undefined): boolean {
        const format = 'hh:mm:ss A'; // 12-hour format with AM/PM
        const signInMoment = moment(signInTime, format);
        const signOutMoment = moment(signOutTime, format);

        return signOutMoment.isSameOrBefore(signInMoment); // Checks if Sign-Out is same or before Sign-In
    }
    

    queryData() {
        this.search['schoolId.equals'] = this.userData.schoolId;
        this.search.size = this.pageContext.itemsPerPage;
        this.search.page = this.pageContext.page;
        this.search.sort = this.pageContext.sort;
        this.search['roomId.equals'] = this.selectedRoomId ?? undefined;

        const { startUtc, endUtc } = Common.getUtcDayRange(this.selectedDate);
        this.search['date.greaterThanOrEqual'] = startUtc;
        this.search['date.lessThanOrEqual'] = endUtc;

        this.search['staffId.equals'] =
            !Common.isAdminUserLogin(this.storage)
                ? this.userData.refTableId
                : undefined;
        // this.search['staffName.contains'] = this.staffSearchID;
        this.search['hasSignIn.equals'] = true;
        this.search['staffId.specified'] = true;
        this.search['designationName.equals'] = this.selectedDesignation;
        this.search['staffName.contains'] = this.staffSearchInput;        
        Common.removeEmptyFields(this.search);
        this.lookupService
            .queryAttendance(this.search)
            .subscribe(async (data: HttpResponse<AttendanceDTO[]>) => {
                let temp: AttendanceDTO[] = [];
                this.staffList =
                    data.body != undefined ? data.body : temp;
                for (const staff of this.staffList) {
                    this.getStaffDetails(staff);
                }
                this.pageContext.totalItems = Number(
                    data.headers.get('X-Total-Count')
                );

                this.staffList.forEach(
                    (element: AttendanceDTO) => {
                        if(this.fromOverView==true){
                        this.selectedStaff = this.staffList.filter(staff =>
                            this.selectedStaffsFromOverview.some(s => s.id === staff.staffId)
                          );
                        } else {
                            this.selectedStaff.forEach((res:AttendanceDTO)=>{
                                if(res.staffId == element.staffId) {
                                    element.selected = res.selected;
                                }
                            });
                        }
                        this.getProfileDocument(element);
                    }
                );
            });
    }
    getProfileDocument(element: AttendanceDTO) {
        if (element.staffPhotoUuid) {
            this.lookupService.queryDocumentByPhotoUid(element.staffPhotoUuid).subscribe((response: HttpResponse<Blob>) => {
              const body = response?.body;
              if (body) {
                const url = this.createImgFromBuffer(body);
                element.profileimg = url;
              }
            });
          } else {
            element.profileimg = undefined;
          }
    }

    getStaffDetails(staff: AttendanceDTO) {
        const staffId = staff?.staffId;
        this.lookupService
            .queryStaff({
                'id.equals': staffId,
                size: PAGE_SIZE,
                'schoolId.equals': this.userData.schoolId,
                'designation.notEquals': 'Kiosk'
            })
            .subscribe(
                (res: HttpResponse<StaffDTO[]>) => {
                    const temp: StaffDTO[] = [];
                    const response: StaffDTO[] = res.body ? res.body : temp;
                    staff.staffs =
                        response && response.length > 0 ? response[0] : {};
                },
                (error: HttpErrorResponse) => {
                    console.error(
                        `Error: ${error.error.title} for staffId: ${staffId}`
                    );
                }
            );
    }

    getRoomData() {
        this.search = {};
        this.search['sort'] = 'name,asc';
        this.search['status.equals'] = 'A';
        this.search['id.notEquals'] = this.roomObj.id;
        this.search.size = 500;
        this.search['schoolId.equals'] = this.userData.schoolId;
        Common.removeEmptyFields(this.search);
        this.lookupService
            .queryRooms(this.search)
            .subscribe((res: HttpResponse<RoomDTO[]>) => {
                let temp: RoomDTO[] = [];
                this.roomList = res.body ? res.body : temp;
            });
    }

    getDesignationData() {
        this.lookupService
            .queryMasterLookups({
                'schoolId.equals': this.userData.schoolId,
                'type.equals': 'Designation',
                'name.notEquals': 'Kiosk',
                'status.equals': 'A',
            })
            .subscribe((res: HttpResponse<MasterLookupDTO[]>) => {
                let temp: MasterLookupDTO[] = [];
                this.designationList = res.body ? res.body : temp;
            });
    }

    createImgFromBuffer(blob: Blob) {
        const url = URL.createObjectURL(blob);
        return url;
    }

    onClear() {
        this.staffSearchInput = undefined;
        this.selectedRoomId = undefined;
        this.selectedDesignation = undefined;
        this.selectedStaff = [];
        this.actualStaffList = [];
        this.selectedStudentIds = [];
        this.selectAllStaff = false;
        this.queryData();
    }

    onRemoveStaff(event: Event, staff: any) {
        this.confirmationService.confirm({
            key: 'confirm2',
            target: event.target as EventTarget,
            message: `Do you want to Remove ${staff.staffName}?`,
            acceptButtonStyleClass: 'p-button-primary p-button-raised',
            rejectButtonStyleClass: 'p-button-secondary p-button-outlined',
            defaultFocus: 'none',
            accept: () => this.deleteStaff(staff),
            reject: () => { },
        });
    }

    deleteStaff(stud: any) {
        try {
            if (!stud || !stud.staffId) {
              throw new Error('Invalid staff data');
            }
      
            if (!this.selectedStaffList || !this.selectedStudentIds || !this.selectedStaff || !this.staffList) {
              throw new Error('Required arrays are not initialized');
            }
      
            this.selectedStaffList = this.selectedStaffList.filter(
              (item) => item.staffId !== stud.staffId
            );
      
            this.selectedStudentIds = this.selectedStudentIds.filter(
              (staffId) => staffId !== stud.staffId
            );
      
            this.selectedStaff = this.selectedStaff.filter(
              (item) => item.staffId !== stud.staffId
            );
      
            const mainListStaff = this.staffList.find(
              (item) => item.staffId === stud.staffId
            );
            if (mainListStaff) {
              mainListStaff.selected = false;
            }
      
            this.selectAllStaff = false;
            this.submitForm = false;
      
            // Show success message
            this.messageService.add({
              key: 'message',
              severity: 'success',
              life: 3000,
              summary: 'Success',
              detail: 'Staff Removed Successfully'
            });
      
          } catch (error) {
            console.error('Error in deleteStaff:', error);
            this.messageService.add({
              key: 'message',
              severity: 'error',
              life: 3000,
              summary: 'Error',
              detail: (error as Error).message || 'Failed to remove staff'
            });
          }
    }

    toggleSelection(staff: any) {
        const index = this.selectedStaff.findIndex(
            (selected) => selected.id === staff.id
        );
        if (index !== -1) {
            this.selectedStaff.splice(index, 1);
        } else {
            this.selectedStaff.push(staff);
        }
        this.selectedStudentIds = this.selectedStaff.map(
            (selected) => selected.id
        );

        this.selectedStaffList = this.actualStaffList.filter((item: StaffDTO) =>
            this.selectedStudentIds.includes(item.id as number)
        );
        // this.selectedStaffList = this.selectedStaff;
    }

    isSelected(staff: StaffDTO): boolean {
        return this.selectedStaff.includes(staff);
    }

    toggleAllSelection() {
        this.staffList.forEach(
            (staff) => (staff.selected = this.selectAllStaff)
        );

        if (this.selectAllStaff) {
            this.selectedStaff = [...this.staffList];
        } else {
            this.selectedStaff = [];
        }
        this.selectedStudentIds = this.selectedStaff.map(
            (selected) => selected.id
        );

        this.selectedStaffList = this.actualStaffList.filter((item: StaffDTO) =>
            this.selectedStudentIds.includes(item.id as number)
        );
        // this.selectedStaffList = this.selectedStaff;
    }

    checkboxChanged() {
        if (this.staffList && this.staffList?.length !== 0) {
            if (this.isAllSelected()) this.selectAllStaff = true;
            else this.selectAllStaff = false;
        } else {
            this.selectAllStaff = false;
        }
    }

    isAllSelected(): boolean {
        return this.staffList.every((staff) => staff.selected);
    }

    private patchDateValue(dateValue: any): string {
        let formattedDate;
        // Check if the value is a valid date before formatting
        if (dateValue && !isNaN(new Date(dateValue).getTime())) {
            formattedDate = Common.convertLocalDateToUTC(dateValue)
        } else {
            // If the value is not a valid date, set it to null or handle it accordingly
            formattedDate = '';
        }
        return formattedDate;
    }

    getBackgroundColor(roomId: number): string {
        if (!roomId) return this.profileBgColor[0];
        const index = (roomId - 1) % this.profileBgColor.length;
        return this.profileBgColor[index];
    }

    getInitials(name: string): string {
        const words = name.trim().split(/[-\s]+/); // Split by hyphens or spaces
        const firstLetter = words[0][0]?.toUpperCase(); // Get the first letter of the first word
        const secondLetter = words[1]?.[0]?.toUpperCase() || ''; // Get the first letter of the second word (if it exists)
        return `${firstLetter}${secondLetter}`.trim(); // Concatenate and trim
    }
}
